// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perfil input{padding-left: 3px;}

.perfil .caja-verde{ width: 350px; }
.perfil .caja-verde.negro{ width: calc(100% - 400px); }

.perfil .formularios{ margin-top: 30px; }

/* -----------------------------------------------------------------------------
// DATOS PERFIL
// ----------------------------------------------------------------------------- */
.main.perfil .usuario{ margin: 0px; }
.perfil .usuario .datos-tecnicos{ width: 350px!important;}

.perfil .usuario .correo,
.mi-perfil .correo
{ font-weight: 600; }


/* -----------------------------------------------------------------------------
// ACTIVAR / INACTIVAR PERFIL
// ----------------------------------------------------------------------------- */
.perfil .tecnico .activar{ width: calc( 100% - 400px);}


/* -----------------------------------------------------------------------------
// CAJAS FORMULARIOS
// ----------------------------------------------------------------------------- */
.perfil .caja-verde .cambio-contrasenas,
.mi-perfil .caja-verde .cambio-contrasenas,
.perfil .caja-verde .nuevo-tecnico{ 
    padding: 30px 30px 20px 25px; 
    gap: 25px;
}

.mi-perfil input{ width: 400px!important; }
.perfil .campo select { border-bottom: none; }
.perfil .error-message{ height: auto; }


/* -----------------------------------------------------------------------------
// CAJA CAMBIO CONTRASEÑA
// ----------------------------------------------------------------------------- */
.perfil .caja-verde h2, .mi-perfil .caja-verde h2{ 
    font-size: 18px;
    border-top-left-radius: 7.5px;
    border-top-right-radius: 7.5px;
    padding: 0px 15px 8px 25px;
}

.perfil .caja-verde .cambio-contrasenas .campo,
.mi-perfil .caja-verde .cambio-contrasenas .campo
{ border-bottom: 1px solid #007932; }


/* -----------------------------------------------------------------------------
// CAJA NUEVO TECNICO
// ----------------------------------------------------------------------------- */
.perfil .caja-verde.negro .campo{ border-bottom: 1px solid #000; }

.caja-verde.negro{
    border: 1px solid #000;
    border-top: 12px solid #000;
}

.caja-verde.negro h2{ background-color:  #000; }

.crear-tecnico{ 
    border: 2px solid #000; 
    color: #000;
}

.crear-tecnico:hover{ 
    background-color: #000;
    color: white;
}


/* -----------------------------------------------------------------------------
// LISTADO TÉCNICOS
// ----------------------------------------------------------------------------- */
.perfil .listado-tecnicos{ 
    margin-top: 80px; 
    margin-bottom: 50px; 
}

.perfil .listado-tecnicos select{
    border: none;
    border-bottom: 1px solid black;
}

.perfil .listado-tecnicos .editar:hover{ color: #007932; }`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Perfil.css"],"names":[],"mappings":"AAAA,cAAc,iBAAiB,CAAC;;AAEhC,qBAAqB,YAAY,EAAE;AACnC,2BAA2B,yBAAyB,EAAE;;AAEtD,sBAAsB,gBAAgB,EAAE;;AAExC;;kFAEkF;AAClF,uBAAuB,WAAW,EAAE;AACpC,kCAAkC,sBAAsB,CAAC;;AAEzD;;EAEE,gBAAgB,EAAE;;;AAGpB;;kFAEkF;AAClF,2BAA2B,0BAA0B,CAAC;;;AAGtD;;kFAEkF;AAClF;;;IAGI,4BAA4B;IAC5B,SAAS;AACb;;AAEA,kBAAkB,sBAAsB,EAAE;AAC1C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,YAAY,EAAE;;;AAGtC;;kFAEkF;AAClF;IACI,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;;EAEE,gCAAgC,EAAE;;;AAGpC;;kFAEkF;AAClF,kCAAkC,6BAA6B,EAAE;;AAEjE;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,sBAAsB,uBAAuB,EAAE;;AAE/C;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;;kFAEkF;AAClF;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,8BAA8B;AAClC;;AAEA,yCAAyC,cAAc,EAAE","sourcesContent":[".perfil input{padding-left: 3px;}\n\n.perfil .caja-verde{ width: 350px; }\n.perfil .caja-verde.negro{ width: calc(100% - 400px); }\n\n.perfil .formularios{ margin-top: 30px; }\n\n/* -----------------------------------------------------------------------------\n// DATOS PERFIL\n// ----------------------------------------------------------------------------- */\n.main.perfil .usuario{ margin: 0px; }\n.perfil .usuario .datos-tecnicos{ width: 350px!important;}\n\n.perfil .usuario .correo,\n.mi-perfil .correo\n{ font-weight: 600; }\n\n\n/* -----------------------------------------------------------------------------\n// ACTIVAR / INACTIVAR PERFIL\n// ----------------------------------------------------------------------------- */\n.perfil .tecnico .activar{ width: calc( 100% - 400px);}\n\n\n/* -----------------------------------------------------------------------------\n// CAJAS FORMULARIOS\n// ----------------------------------------------------------------------------- */\n.perfil .caja-verde .cambio-contrasenas,\n.mi-perfil .caja-verde .cambio-contrasenas,\n.perfil .caja-verde .nuevo-tecnico{ \n    padding: 30px 30px 20px 25px; \n    gap: 25px;\n}\n\n.mi-perfil input{ width: 400px!important; }\n.perfil .campo select { border-bottom: none; }\n.perfil .error-message{ height: auto; }\n\n\n/* -----------------------------------------------------------------------------\n// CAJA CAMBIO CONTRASEÑA\n// ----------------------------------------------------------------------------- */\n.perfil .caja-verde h2, .mi-perfil .caja-verde h2{ \n    font-size: 18px;\n    border-top-left-radius: 7.5px;\n    border-top-right-radius: 7.5px;\n    padding: 0px 15px 8px 25px;\n}\n\n.perfil .caja-verde .cambio-contrasenas .campo,\n.mi-perfil .caja-verde .cambio-contrasenas .campo\n{ border-bottom: 1px solid #007932; }\n\n\n/* -----------------------------------------------------------------------------\n// CAJA NUEVO TECNICO\n// ----------------------------------------------------------------------------- */\n.perfil .caja-verde.negro .campo{ border-bottom: 1px solid #000; }\n\n.caja-verde.negro{\n    border: 1px solid #000;\n    border-top: 12px solid #000;\n}\n\n.caja-verde.negro h2{ background-color:  #000; }\n\n.crear-tecnico{ \n    border: 2px solid #000; \n    color: #000;\n}\n\n.crear-tecnico:hover{ \n    background-color: #000;\n    color: white;\n}\n\n\n/* -----------------------------------------------------------------------------\n// LISTADO TÉCNICOS\n// ----------------------------------------------------------------------------- */\n.perfil .listado-tecnicos{ \n    margin-top: 80px; \n    margin-bottom: 50px; \n}\n\n.perfil .listado-tecnicos select{\n    border: none;\n    border-bottom: 1px solid black;\n}\n\n.perfil .listado-tecnicos .editar:hover{ color: #007932; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
